import React, { useState, useEffect } from "react";
import * as S from "./HobListingStyles";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import PopUp from "../PopUp/Popup";
import { useHistory } from "react-router-dom";
import {
  API_STATUS,
  CONSTANTS,
  DASHED_LINE_URL,
  DEFAULT_CONTACT_DETAILS,
  GOIBIBO,
  GOIBIBO_ICON_URL,
  GOLD_STAR_URL,
  HOB_BOTTOMSHEET_CANCEL,
  HOB_BOTTOMSHEET_COMM_TXT,
  HOB_BOTTOMSHEET_CONFIRM_BOOKING,
  HOB_BOTTOMSHEET_EMAIL,
  HOB_BOTTOMSHEET_FULL_NAME,
  HOB_BOTTOMSHEET_INFO,
  HOB_BOTTOMSHEET_MOB_NO,
  HOB_LEFT_ICON,
  PLEASE_CONFIRM_TRAVELLER_DETLS,
  PLEASE_ENTER_FULL_NAME,
  PLEASE_ENTER_VALID_EMAIL,
  PLEASE_ENTER_VALID_MOBILE_NO,
  PROVISIONAL_HOB_REQUEST_TYPE,
  TRAVELLER_DETAILS,
  WHITE_STAR_URL,
  errActionCta,
  errIcon,
} from "../../../../../config/constants";
import {
  getHoldResponseForHOB,
  getCheckFareHOB,
  checkHobUserDetails,
} from "../../../redux/thunks";
import { useDispatch, useSelector, useStore } from "react-redux";
import {
  hobAirportCityCodeSelector,
  hobDestinationLocationSelector,
  hobFlightIdSelector,
  hobIsDepartureSelector,
  hobPickupTimeSelector,
  hobSourceLocationSelector,
  hobSourceMessageSelector,
  hobSourceSelector,
  hobTerminalSelector,
  useSourceLocationSelector,
} from "../../../redux/selector";
import { UPDATE_HOB_LISTING_RESPONSE } from "../../../redux/action-types";
import {
  gcHobListingScreen,
  pageViewOmniEvent,
  pushCtaOmniEvents,
  sendEventOnError,
} from "../../../../../config/omni";
import {
  ANOTHER_BOOKING_CLOSE_CLICKED,
  ANOTHER_BOOKING_CONFIRM_CLICKED,
  ANOTHER_BOOKING_POPUP_SHOWN,
  CABS_HOB_LISTING_ROUTE,
  CONFIRM_BOOKING_CLICKED,
  DYNAMIC_ERROR,
  HEADER_BACK_CLICKED,
  HOB_CAB_AVAILABLE,
  HOB_CAB_NOT_AVAILABLE,
  HOB_LISTING_PAGE,
  HOLD,
  LISTING_FILTER,
  LOGIN_CLOSE,
  LOGIN_SHOWN,
  LOGIN_SUCCESS,
  MOB_CABS_HOB_LISTING,
  OS_SEARCH,
  SELECTED,
  SUPPLIER_NAME,
  SUPPLIER_SHOWN,
  USER_DETAILS_CLOSED,
  USER_DETAILS_SHOWN,
} from "../../../../../utils/util-constants";
import { CTA_TYPE } from "../../../../../utils/omni-utils";
import FilterBar from "../FilterBar/FilterBar";
import HobBottomSheet from "../../HobBottomSheet/HobBottomSheet";
import { MwebAuth } from "@growth/gi-mweb-auth";
import ErrorScreen from "../../../HobLanding/gi-components/ErrorScreen/ErrorScreen";
import { formValidator } from "../../../../../config/utils";
import AnotherBookingPopup from "../AnotherBookingPopup/AnotherBookingPopup";
import CustomRadioButton from "../../../../../../stories/core-components/CustomRadioButtonUI/CustomRadioButtonUI";
import SlideButton from "../SliderButton/SliderButton";
import { formatDateTime } from "../../../utils";

const HobListing = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useStore();

  const [selectedCardKey, setSelectedKey] = useState(null);
  const [selectedCardData, setSelectedCardData] = useState(null);
  const [holdStatus, setHoldStatus] = useState(API_STATUS.INITIAL);
  const [holdApiResponse, setHoldApiResponse] = useState({});
  const [checkFareApiStatus, setCheckFareApiStatus] = useState(
    API_STATUS.INITIAL
  );
  const [checkHobUserStatus, setCheckHobUserStatus] = useState(
    API_STATUS.INITIAL
  );
  const [apiResponse, setApiResponse] = useState({});
  const [holdPopUpMessage, setHoldPopUpMessage] = useState("");
  const [checkFarePopUpMessage, setCheckFarePopUpMessage] = useState("");
  const [data, setData] = useState({});
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [preferedCabList, setPreferedCabList] = useState([]);
  const [othersCabList, setOthersCabList] = useState([]);
  const [hobUserDetailsData, setHobUserDetailsData] = useState(null);
  const [errScreenData, setErrScreenData] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [showWidget, setShowWidget] = useState(false);
  const [isPopupShown, setIsPopupShown] = useState(false);
  const [isLoginShown, setIsLoginShown] = useState(false);
  const [welcomeText, setWelcomeText] = useState("");
  const [showInputError, setShowInputError] = useState({
    name: false,
    email: false,
    mobile: false,
  });
  const [formDetails, setFormDetails] = useState({
    gender: "M",
    first_name: null,
    last_name: null,
    email: null,
    mobileNumber: null,
  });

  const flightId = useSelector(hobFlightIdSelector);
  const source = useSelector(hobSourceSelector);
  const isDeparture = useSelector(hobIsDepartureSelector);
  const pickupTime = useSelector(hobPickupTimeSelector);
  const destinationLocation = useSelector(hobDestinationLocationSelector);
  const sourceMessage = useSelector(hobSourceMessageSelector);
  const terminal = useSelector(hobTerminalSelector);
  const airportCityCode = useSelector(hobAirportCityCodeSelector);
  const sourceLocation = useSelector(hobSourceLocationSelector);
  const useSourceLocation = useSelector(useSourceLocationSelector);
  const [reset, setReset] = useState(0);
  const showSlidingPayment = false;
  const sliderSecondaryText = "BOOKING AT ₹0";

  const returnVendorsArray = (data = null) => {
    const suppliersArray = [];
    data?.isMMTPreferred?.cards?.forEach((card) => {
      suppliersArray.push(card?.brand?.title);
    });
    data?.others?.cards?.forEach((card) => {
      suppliersArray.push(card?.brand?.title);
    });
    return suppliersArray;
  };

  const handleCheckFareResponse = (checkFareResponse) => {
    setApiResponse(checkFareResponse);
    dispatch({
      type: UPDATE_HOB_LISTING_RESPONSE,
      data: checkFareResponse?.response,
    });
    if (Boolean(checkFareResponse?.errors?.error_list?.length)) {
      pushCtaOmniEvents(
        `${MOB_CABS_HOB_LISTING}_${DYNAMIC_ERROR}_${
          checkFareResponse?.errors?.error_list[0]?.code || ""
        }_${airportCityCode}`,
        CTA_TYPE.HYPER_LINK,
        HOB_LISTING_PAGE,
        CABS_HOB_LISTING_ROUTE
      );
      sendEventOnError([
        {
          field: `hob_listing_load_error_${
            checkFareResponse?.errors?.error_list[0]?.code || ""
          }`,
          message: `${
            checkFareResponse?.errors?.error_list[0]?.message ?? ""
          }_${airportCityCode}_${destinationLocation?.address}`,
        },
      ]);

      setCheckFareApiStatus(API_STATUS.INITIAL);
      setCheckFarePopUpMessage(
        checkFareResponse?.errors?.error_list[0]?.message ||
          checkFareResponse?.errors?.error_list[0]?.code
      );
      return;
    }

    const suppliersString = returnVendorsArray(
      checkFareResponse?.response?.funnel_cab_card
    ).join(" | ");
    pageViewOmniEvent(store.getState(), gcHobListingScreen);

    setTimeout(() => {
      if (checkFareResponse?.response?.funnel_cab_card) {
        pushCtaOmniEvents(
          `${MOB_CABS_HOB_LISTING}_${HOB_CAB_AVAILABLE}`,
          CTA_TYPE.HYPER_LINK,
          HOB_LISTING_PAGE,
          CABS_HOB_LISTING_ROUTE
        );
      } else {
        pushCtaOmniEvents(
          `${MOB_CABS_HOB_LISTING}_${HOB_CAB_NOT_AVAILABLE}`,
          CTA_TYPE.HYPER_LINK,
          HOB_LISTING_PAGE,
          CABS_HOB_LISTING_ROUTE
        );
      }
    }, 10);
    if (checkFareResponse?.response?.filters?.length) {
      pushCtaOmniEvents(
        `${MOB_CABS_HOB_LISTING}_${checkFareResponse?.response?.filters?.join(
          "_"
        )}_Shown`,
        CTA_TYPE.BUTTON,
        HOB_LISTING_PAGE,
        CABS_HOB_LISTING_ROUTE
      );
    }
    pushCtaOmniEvents(
      `${MOB_CABS_HOB_LISTING}_${SUPPLIER_SHOWN}_${suppliersString}`,
      CTA_TYPE.HYPER_LINK,
      HOB_LISTING_PAGE,
      CABS_HOB_LISTING_ROUTE
    );
    if (checkFareResponse?.response?.trip_type === CONSTANTS.OW) {
      setTimeout(() => {
        pushCtaOmniEvents(
          `${MOB_CABS_HOB_LISTING}_${OS_SEARCH}`,
          CTA_TYPE.HYPER_LINK,
          HOB_LISTING_PAGE,
          CABS_HOB_LISTING_ROUTE
        );
      }, 10);
    }

    setCheckFareApiStatus(API_STATUS.SUCCESS);
  };

  const formatTextWithBold = (text) => {
    const boldRegex = /\*([^*]+)\*/g;
    return text.split(boldRegex).map((part, index) => {
      if (index % 2 === 0) {
        return part;
      } else {
        return <strong key={index}>{part}</strong>;
      }
    });
  };

  const getCheckFareRequest = () => {
    let reqParams = {};
    if (flightId && !sourceLocation) {
      reqParams = {
        type: PROVISIONAL_HOB_REQUEST_TYPE,
        tracking_params: null,
        device_info: null,
        flight_id: flightId,
        destination_location: destinationLocation,
        source_param: source,
        is_departure: isDeparture,
        pickup_time: pickupTime != null ? parseFloat(pickupTime) : null,
        source_message: sourceMessage,
      };
    } else {
      reqParams = {
        type: PROVISIONAL_HOB_REQUEST_TYPE,
        tracking_params: null,
        device_info: null,
        source_location: sourceLocation,
        destination_location: destinationLocation,
        source_param: source,
        is_departure: isDeparture,
        pickup_time: pickupTime != null ? parseFloat(pickupTime) : null,
        source_message: sourceMessage,
      };

      if (flightId) reqParams["flight_id"] = flightId;
    }
    return reqParams;
  };

  const fetchCheckFareResponse = async () => {
    const checkFareRequest = getCheckFareRequest();
    try {
      setCheckFareApiStatus(API_STATUS.LOADING);
      const checkFareResponse = await getCheckFareHOB(checkFareRequest);
      handleCheckFareResponse(checkFareResponse);
    } catch (e) {
      setCheckFareApiStatus(API_STATUS.INITIAL);
      return;
    }
  };

  useEffect(() => {
    fetchCheckFareResponse();
  }, []);

  useEffect(() => {
    if (
      holdStatus === API_STATUS.SUCCESS &&
      holdApiResponse?.status === CONSTANTS.SUCCESS &&
      holdApiResponse?.response?.tyPageUrl &&
      typeof window !== "undefined"
    ) {
      window.location.replace(holdApiResponse?.response?.tyPageUrl);
    }
  }, [holdStatus, holdApiResponse]);

  useEffect(() => {
    if (apiResponse) {
      setData(apiResponse?.response);
      setSelectedFilters(
        apiResponse?.response?.pre_selected_filter
          ? [apiResponse?.response?.pre_selected_filter]
          : []
      );
    }
  }, [apiResponse]);

  useEffect(() => {
    const newPreferedCabs =
      selectedFilters?.length > 0
        ? data?.funnel_cab_card?.isMMTPreferred?.cards?.filter((card) =>
            selectedFilters?.includes(card?.cab_offering?.cab_type)
          ) || []
        : data?.funnel_cab_card?.isMMTPreferred?.cards;

    const newOthersCabs =
      selectedFilters?.length > 0
        ? data?.funnel_cab_card?.others?.cards?.filter((card) =>
            selectedFilters?.includes(card?.cab_offering?.cab_type)
          ) || []
        : data?.funnel_cab_card?.others?.cards;

    setPreferedCabList(newPreferedCabs);
    setOthersCabList(newOthersCabs);
  }, [selectedFilters]);

  useEffect(() => {
    if (preferedCabList?.length > 0) {
      handleCardClick(preferedCabList[0], true);
    } else if (othersCabList?.length > 0) {
      handleCardClick(othersCabList[0], true);
    }
  }, [preferedCabList, othersCabList]);

  const checkHobUser = async (loginSuccess: boolean = false) => {
    if (hobUserDetailsData?.showLogin && !loginSuccess) {
      setShowLogin(true);
      return;
    }

    const req = {
      type: "userDetailsRequest",
      pickup_time: pickupTime != null ? parseFloat(pickupTime) : null,
    };
    setCheckHobUserStatus(API_STATUS.LOADING);

    try {
      const checkHobUserResp = await checkHobUserDetails(req);

      if (Boolean(checkHobUserResp?.errors?.error_list?.length)) {
        pushCtaOmniEvents(
          `${MOB_CABS_HOB_LISTING}_${DYNAMIC_ERROR}_${
            checkHobUserResp?.errors?.error_list[0]?.code || ""
          }`,
          CTA_TYPE.HYPER_LINK,
          HOB_LISTING_PAGE,
          CABS_HOB_LISTING_ROUTE
        );
        sendEventOnError([
          {
            field: `hob_listing_load_error_${
              checkHobUserResp?.errors?.error_list[0]?.code || ""
            }`,
            message: `${
              checkHobUserResp?.errors?.error_list[0]?.message ?? ""
            }_${airportCityCode}_${destinationLocation?.address}`,
          },
        ]);
        setErrScreenData(checkHobUserResp?.errors?.error_list[0]);
        setCheckHobUserStatus(API_STATUS.INITIAL);
      } else {
        setHobUserDetailsData(checkHobUserResp?.response);

        if (checkHobUserResp?.response?.userDetails) {
          const formDetailsVal = {
            first_name: checkHobUserResp?.response?.userDetails?.lastName
              ?.length
              ? checkHobUserResp?.response?.userDetails?.firstName +
                " " +
                checkHobUserResp?.response?.userDetails?.lastName
              : checkHobUserResp?.response?.userDetails?.firstName,
            last_name: "",
            email: checkHobUserResp?.response?.userDetails?.email,
            mobileNumber: checkHobUserResp?.response?.userDetails?.mobileNumber,
            gender: checkHobUserResp?.response?.userDetails?.gender?.length
              ? checkHobUserResp?.response?.userDetails?.gender
              : "M",
          };
          setFormDetails(formDetailsVal);
        }

        if (checkHobUserResp?.response?.bookingPopUp) {
          pushCtaOmniEvents(
            `${MOB_CABS_HOB_LISTING}_${ANOTHER_BOOKING_POPUP_SHOWN}`,
            CTA_TYPE.HYPER_LINK,
            HOB_LISTING_PAGE,
            CABS_HOB_LISTING_ROUTE
          );
          if (isLoginShown) {
            setWelcomeText(
              `Welcome Back ${checkHobUserResp?.response?.userDetails?.firstName} !`
            );
            setIsLoginShown(false);
          }
          setCheckHobUserStatus(API_STATUS.SUCCESS);
          return;
        }

        if (checkHobUserResp?.response?.showLogin) {
          pushCtaOmniEvents(
            `${MOB_CABS_HOB_LISTING}_${LOGIN_SHOWN}`,
            CTA_TYPE.HYPER_LINK,
            HOB_LISTING_PAGE,
            CABS_HOB_LISTING_ROUTE
          );
          setCheckHobUserStatus(API_STATUS.SUCCESS);
          setIsLoginShown(true);
          setShowLogin(true);
        } else if (checkHobUserResp?.response?.showWidget) {
          pushCtaOmniEvents(
            `${MOB_CABS_HOB_LISTING}_${USER_DETAILS_SHOWN}`,
            CTA_TYPE.HYPER_LINK,
            HOB_LISTING_PAGE,
            CABS_HOB_LISTING_ROUTE
          );
          setCheckHobUserStatus(API_STATUS.SUCCESS);
          setShowWidget(true);
          if (isLoginShown) {
            setWelcomeText(
              `Welcome Back ${checkHobUserResp?.response?.userDetails?.firstName} !`
            );
            setIsLoginShown(false);
          }
        }
      }
    } catch (e) {
      setCheckHobUserStatus(API_STATUS.INITIAL);
      return;
    }
  };

  const checkFormError = (key: string): boolean => {
    const isValid = formDetails[key]?.length
      ? formValidator({
          type: key === "mobileNumber" ? "phone_number" : key,
          value: formDetails[key],
        })
      : false;
    return isValid;
  };

  const isFormDetailsError = (): boolean => {
    const isNameValid = checkFormError("first_name");
    const isEmailValid = checkFormError("email");
    const isMobileValid = checkFormError("mobileNumber");

    setShowInputError({
      name: !isNameValid,
      email: !isEmailValid,
      mobile: !isMobileValid,
    });

    return !isNameValid || !isEmailValid || !isMobileValid;
  };

  /**
   * Handles the process of booking a cab, performs necessary checks, calls hold api,and updates the booking status accordingly.
   * @returns {void}
   */
  const handleBookClick = async () => {
    setReset((r) => r + 1);
    if (!flightId && !hobUserDetailsData?.showWidget) {
      checkHobUser();
    } else {
      if (!flightId && isFormDetailsError()) {
        setShowWidget(true);
        return;
      }
      pushCtaOmniEvents(
        `${MOB_CABS_HOB_LISTING}_${CONFIRM_BOOKING_CLICKED}`,
        CTA_TYPE.HYPER_LINK,
        HOB_LISTING_PAGE,
        CABS_HOB_LISTING_ROUTE
      );
      setTimeout(() => {
        pushCtaOmniEvents(
          `${MOB_CABS_HOB_LISTING}_${SUPPLIER_NAME}_${selectedCardData?.brand?.title}_${SELECTED}`,
          CTA_TYPE.HYPER_LINK,
          HOB_LISTING_PAGE,
          CABS_HOB_LISTING_ROUTE
        );
      }, 10);

      let holdRequest = {};

      if (!flightId) {
        holdRequest = {
          type: CONSTANTS.holdBookingRequest,
          destination_location: data?.destination_location,
          version: CONSTANTS.V3,
          source_location: data?.source_location,
          advance_type: CONSTANTS.ZERO_PAYMENT,
          funnel_source: CONSTANTS.hob_funnel,
          search_id: selectedCardData?.search_id,
          cab_key: selectedCardData?.cab_key,
          category_id: selectedCardData?.category_id,
          hob_search_id: data?.hob_search_id,
          userDetails: hobUserDetailsData?.userDetails,
          passenger_details: formDetails,
          flow_name: source,
        };
      } else {
        holdRequest = {
          type: CONSTANTS.holdBookingRequest,
          flight_booking_id: flightId,
          destination_location: data?.destination_location,
          version: CONSTANTS.V3,
          source_location: data?.source_location,
          advance_type: CONSTANTS.ZERO_PAYMENT,
          funnel_source: CONSTANTS.hob,
          search_id: selectedCardData?.search_id,
          cab_key: selectedCardData?.cab_key,
          category_id: selectedCardData?.category_id,
          provBookingId: data?.prov_booking_id,
          flow_name: source,
        };
      }

      try {
        setHoldStatus(API_STATUS.LOADING);
        const holdResponse = await getHoldResponseForHOB(holdRequest);

        setHoldApiResponse(holdResponse);
        if (Boolean(holdResponse?.errors?.error_list?.length)) {
          pushCtaOmniEvents(
            `${MOB_CABS_HOB_LISTING}_${HOLD}_${DYNAMIC_ERROR}_${holdResponse.errors?.error_list[0].code}`,
            CTA_TYPE.BUTTON,
            HOB_LISTING_PAGE,
            CABS_HOB_LISTING_ROUTE
          );
          sendEventOnError([
            {
              field: `hob_hold_response_error`,
              message: `${holdResponse.errors?.error_list[0].code}_${
                data?.source_location?.address || ""
              }_${data?.destination_location?.address || ""}`,
            },
          ]);

          setHoldStatus(API_STATUS.INITIAL);
          setHoldPopUpMessage(
            holdResponse?.errors?.error_list[0]?.message ||
              holdResponse?.errors?.error_list[0]?.code
          );
          return;
        }
      } catch (e) {
        setHoldStatus(API_STATUS.INITIAL);
        return;
      }
      setHoldStatus(API_STATUS.SUCCESS);
    }
  };

  const formattedDetail = data?.search_detail?.map((item, index, array) => {
    return (
      <span key={index}>
        {formatTextWithBold(item)}
        {index !== array.length - 1 && (
          <span style={{ margin: "0 4px" }}>|</span>
        )}
      </span>
    );
  });

  const handleBack = (isHeaderBackClicked = false) => {
    if (isHeaderBackClicked) {
      pushCtaOmniEvents(
        `${MOB_CABS_HOB_LISTING}_${HEADER_BACK_CLICKED}`,
        CTA_TYPE.BUTTON,
        HOB_LISTING_PAGE,
        CABS_HOB_LISTING_ROUTE
      );
    }
    history.goBack();
  };

  const handleCardClick = (card, isPreSelectCall = false) => {
    setSelectedKey(card?.cab_key + card?.search_id);
    setSelectedCardData(card);
  };

  const handleFilterSelect = (filter: string) => {
    pushCtaOmniEvents(
      `${MOB_CABS_HOB_LISTING}_${LISTING_FILTER}_${filter}`,
      CTA_TYPE.BUTTON,
      HOB_LISTING_PAGE,
      CABS_HOB_LISTING_ROUTE
    );
    setSelectedFilters([filter]);
  };

  const onUserDetailsUpdate = (key: string, val: string) => {
    const newFormDetails = { ...formDetails };
    setFormDetails({ ...newFormDetails, [key]: val });
  };

  const onClose = (isLogin = false) => {
    if (isLogin) {
      pushCtaOmniEvents(
        `${MOB_CABS_HOB_LISTING}_${LOGIN_CLOSE}`,
        CTA_TYPE.BUTTON,
        HOB_LISTING_PAGE,
        CABS_HOB_LISTING_ROUTE
      );
      setShowLogin(false);
    } else {
      pushCtaOmniEvents(
        `${MOB_CABS_HOB_LISTING}_${USER_DETAILS_CLOSED}`,
        CTA_TYPE.BUTTON,
        HOB_LISTING_PAGE,
        CABS_HOB_LISTING_ROUTE
      );
      setShowWidget(false);
    }
  };

  const onLoginSuccess = () => {
    pushCtaOmniEvents(
      `${MOB_CABS_HOB_LISTING}_${LOGIN_SUCCESS}`,
      CTA_TYPE.BUTTON,
      HOB_LISTING_PAGE,
      CABS_HOB_LISTING_ROUTE
    );
    setShowLogin(false);
    checkHobUser(true);
  };

  const onPositiveAction = () => {
    pushCtaOmniEvents(
      `${MOB_CABS_HOB_LISTING}_${ANOTHER_BOOKING_CONFIRM_CLICKED}`,
      CTA_TYPE.BUTTON,
      HOB_LISTING_PAGE,
      CABS_HOB_LISTING_ROUTE
    );
    setIsPopupShown(true);
    setShowWidget(true);
  };

  const onNegativeAction = () => {
    pushCtaOmniEvents(
      `${MOB_CABS_HOB_LISTING}_${ANOTHER_BOOKING_CLOSE_CLICKED}`,
      CTA_TYPE.BUTTON,
      HOB_LISTING_PAGE,
      CABS_HOB_LISTING_ROUTE
    );
    handleBack(false);
  };

  if (errScreenData) {
    return (
      <ErrorScreen
        title={errScreenData?.title}
        message={errScreenData?.message || errScreenData?.code}
        icon={errIcon}
        cta={errActionCta}
        isListing={true}
      />
    );
  }

  if (
    hobUserDetailsData?.bookingPopUp &&
    Object.keys(hobUserDetailsData?.bookingPopUp)?.length &&
    !isPopupShown
  ) {
    return (
      <AnotherBookingPopup
        shouldShow={true}
        onPositiveAction={onPositiveAction}
        onNegativeAction={onNegativeAction}
        popupDetails={hobUserDetailsData?.bookingPopUp}
      />
    );
  }

  if (Boolean(checkFarePopUpMessage)) {
    return (
      <PopUp
        onCrossClick={() => {
          setCheckFarePopUpMessage("");
          handleBack(false);
        }}
        shouldShow={Boolean(checkFarePopUpMessage)}
        popUpMessage={checkFarePopUpMessage}
      />
    );
  }

  if (Boolean(holdPopUpMessage)) {
    return (
      <PopUp
        onCrossClick={() => {
          setHoldPopUpMessage("");
          history.go(0);
        }}
        shouldShow={Boolean(holdPopUpMessage)}
        popUpMessage={holdPopUpMessage}
      />
    );
  }

  if (checkFareApiStatus === API_STATUS.LOADING) return <LoadingScreen />;

  if (
    checkFareApiStatus === API_STATUS.SUCCESS &&
    apiResponse?.status === CONSTANTS.SUCCESS
  ) {
    return (
      <S.BrandListingScreen>
        <div className="brand-listing-header">
          <div className="header-container">
            <img className="brand-mmt-logo" src={GOIBIBO_ICON_URL} />
            <span className="brand-mmt-header-title">{GOIBIBO}</span>
          </div>
          <div className="trip-destination-view">
            <img
              src={HOB_LEFT_ICON}
              className="brand-back-btn"
              onClick={() => handleBack(true)}
            ></img>
            <S.TripInfo>
              <S.SingleLineLocation>
                {`${
                  (terminal && !useSourceLocation
                    ? terminal
                    : data?.source_location?.address) || ""
                } to ${data?.destination_location?.address || ""}`}
              </S.SingleLineLocation>
              {data?.pickup_time && (
                <S.SingleLineTime>
                  {formatDateTime(data?.pickup_time)}
                </S.SingleLineTime>
              )}
            </S.TripInfo>
          </div>
        </div>
        <div className="brand-listing-container">
          <div className="brand-filter-sec">
            <p>
              <span className="filterTexts">{formattedDetail}</span>
            </p>
          </div>
          {data?.filters && (
            <FilterBar
              filters={data?.filters}
              onFilterSelect={handleFilterSelect}
              selectedFilters={selectedFilters}
            />
          )}
          <div className="listing-section">
            <div className="brand-cab-card-container">
              {data?.funnel_cab_card?.isMMTPreferred &&
              preferedCabList?.length > 0 ? (
                <div>
                  <div className="recommended-section">
                    <span className="reLabel">
                      {data?.funnel_cab_card?.isMMTPreferred?.text}
                    </span>
                    <span className="circleSeperate"></span>
                    <div className="preferredTxt">
                      {data?.funnel_cab_card?.isMMTPreferred?.sub_text}
                    </div>
                  </div>
                  <div>
                    {preferedCabList?.map((card, i) => (
                      <div
                        key={card?.cab_key + card?.search_id}
                        className={`brand-cab-card ${
                          selectedCardKey === card?.cab_key + card?.search_id
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => handleCardClick(card, false)}
                      >
                        <div className="brand-cab-details">
                          <div className="img-section">
                            <div className="img-brandLogo">
                              <S.BrandImgSec src={card?.brand?.icon} />
                            </div>
                            <img
                              className="brand-cab-img"
                              src={card?.cab_offering?.cab_image}
                            />
                          </div>
                          <div className="brand-cab-info">
                            <S.BrandLabelContainer>
                              <div className="brand-label">
                                <div>
                                  <p className="brand-name-cab">
                                    {card?.brand?.title}
                                  </p>
                                  {card?.brand?.rating && (
                                    <div className="cab-rating-box">
                                      <S.StarImgIc src={WHITE_STAR_URL} />
                                      <span>{card?.brand?.rating}</span>
                                    </div>
                                  )}
                                </div>
                                <p className="brand-car-name">
                                  {card?.cab_offering?.cab_type}
                                  {card?.cab_offering?.seat_label && (
                                    <>
                                      <span className="dot-separator"> • </span>
                                      {card?.cab_offering?.seat_label}
                                    </>
                                  )}
                                </p>
                              </div>
                              <div>
                                <S.TimeLeftText>
                                  {card?.waiting_time}
                                </S.TimeLeftText>
                              </div>
                            </S.BrandLabelContainer>
                            <S.BrandFareInfo>
                              <p className="total-amt-txt">{`\u20B9${card?.cab_offering?.current_price?.toLocaleString(
                                "en-US"
                              )}`}</p>
                              <p className="tax-msg-txt">
                                {card?.cab_offering?.cab_type_label}
                              </p>
                            </S.BrandFareInfo>
                          </div>
                        </div>
                        {card?.persuasions && (
                          <>
                            <S.LineImg src={DASHED_LINE_URL} />
                            <div className="brand-features">
                              {card?.persuasions?.map((feature, i) => {
                                return (
                                  <div
                                    key={"brand-features" + i}
                                    className="brand-feat-item"
                                  >
                                    {i === 0 ? (
                                      <div
                                        style={{
                                          background: card?.persuasion_color,
                                        }}
                                        className="featureImgCont"
                                      >
                                        <img
                                          src={GOLD_STAR_URL}
                                          className="golIcImg"
                                        ></img>
                                      </div>
                                    ) : (
                                      <div
                                        className="dotSeperate-feature"
                                        style={{
                                          backgroundColor:
                                            card?.persuasion_color,
                                        }}
                                      />
                                    )}
                                    <span
                                      style={{ color: card?.persuasion_color }}
                                      className="brand-feature-text"
                                    >
                                      {feature}
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                  {othersCabList?.length > 0 && (
                    <S.OtherOptionText>
                      {data?.funnel_cab_card?.others?.text}
                    </S.OtherOptionText>
                  )}
                  {othersCabList?.map((card, i) => (
                    <div
                      key={card?.cab_key + card?.search_id}
                      className={`brand-cab-card ${
                        selectedCardKey === card?.cab_key + card?.search_id
                          ? "selected"
                          : ""
                      }`}
                      onClick={() => handleCardClick(card, false)}
                    >
                      <div className="brand-cab-details">
                        <div className="img-section">
                          <div className="img-brandLogo">
                            <S.BrandImgSec src={card?.brand?.icon} />
                          </div>
                          <img
                            className="brand-cab-img"
                            src={card?.cab_offering?.cab_image}
                          />
                        </div>
                        <div className="brand-cab-info">
                          <S.BrandLabelContainer>
                            <div className="brand-label">
                              <div>
                                <p className="brand-name-cab">
                                  {card?.brand?.title}
                                </p>
                                {card?.brand?.rating && (
                                  <div className="cab-rating-box">
                                    <S.StarImgIc src={WHITE_STAR_URL} />
                                    <span>{card?.brand?.rating}</span>
                                  </div>
                                )}
                              </div>
                              <p className="brand-car-name">
                                {card?.cab_offering?.cab_type}
                                {card?.cab_offering?.seat_label && (
                                  <>
                                    <span className="dot-separator"> • </span>
                                    {card?.cab_offering?.seat_label}
                                  </>
                                )}
                              </p>
                            </div>
                            <div>
                              <S.TimeLeftText>
                                {card?.waiting_time}
                              </S.TimeLeftText>
                            </div>
                          </S.BrandLabelContainer>
                          <S.BrandFareInfo>
                            <p className="total-amt-txt">{`\u20B9${card?.cab_offering?.current_price?.toLocaleString(
                              "en-US"
                            )}`}</p>
                            <p className="tax-msg-txt">
                              {card?.cab_offering?.cab_type_label}
                            </p>
                          </S.BrandFareInfo>
                        </div>
                      </div>
                      {card?.persuasions && (
                        <>
                          <S.LineImg src={DASHED_LINE_URL} />
                          <div className="brand-features">
                            {card?.persuasions?.map((feature, i) => {
                              return (
                                <div
                                  key={"brand-features" + i}
                                  className="brand-feat-item"
                                >
                                  {i === 0 ? (
                                    <div
                                      style={{
                                        background: card?.persuasion_color,
                                      }}
                                      className="featureImgCont"
                                    >
                                      <img
                                        src={GOLD_STAR_URL}
                                        className="golIcImg"
                                      ></img>
                                    </div>
                                  ) : (
                                    <div
                                      className="dotSeperate-feature"
                                      style={{
                                        backgroundColor: card?.persuasion_color,
                                      }}
                                    />
                                  )}
                                  <span
                                    style={{ color: card?.persuasion_color }}
                                    className="brand-feature-text"
                                  >
                                    {feature}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  {othersCabList?.length > 0 && (
                    <S.OtherRecommendedSection>
                      {data?.funnel_cab_card?.others?.text}
                    </S.OtherRecommendedSection>
                  )}
                  {othersCabList?.map((card, i) => (
                    <div
                      key={card?.cab_key + card?.search_id}
                      className={`brand-cab-card ${
                        selectedCardKey === card?.cab_key + card?.search_id
                          ? "selected"
                          : ""
                      }`}
                      onClick={() => handleCardClick(card, false)}
                    >
                      <div className="brand-cab-details">
                        <div className="img-section">
                          <div className="img-brandLogo">
                            <S.BrandImgSec src={card?.brand?.icon} />
                          </div>
                          <img
                            className="brand-cab-img"
                            src={card?.cab_offering?.cab_image}
                          />
                        </div>
                        <div className="brand-cab-info">
                          <S.BrandLabelContainer>
                            <div className="brand-label">
                              <div>
                                <p className="brand-name-cab">
                                  {card?.brand?.title}
                                </p>
                                {card?.brand?.rating && (
                                  <div className="cab-rating-box">
                                    <S.StarImgIc src={WHITE_STAR_URL} />
                                    <span>{card?.brand?.rating}</span>
                                  </div>
                                )}
                              </div>
                              <p className="brand-car-name">
                                {card?.cab_offering?.cab_type}
                                {card?.cab_offering?.seat_label && (
                                  <>
                                    <span className="dot-separator"> • </span>
                                    {card?.cab_offering?.seat_label}
                                  </>
                                )}
                              </p>
                            </div>
                            <div>
                              <S.TimeLeftText>
                                {card?.waiting_time}
                              </S.TimeLeftText>
                            </div>
                          </S.BrandLabelContainer>
                          <S.BrandFareInfo>
                            <p className="total-amt-txt">{`\u20B9${card?.cab_offering?.current_price?.toLocaleString(
                              "en-US"
                            )}`}</p>
                            <p className="tax-msg-txt">
                              {card?.cab_offering?.cab_type_label}
                            </p>
                          </S.BrandFareInfo>
                        </div>
                      </div>
                      {card?.persuasions && (
                        <>
                          <S.LineImg src={DASHED_LINE_URL} />
                          <div className="brand-features">
                            {card?.persuasions?.map((feature, i) => {
                              return (
                                <div
                                  key={"brand-features" + i}
                                  className="brand-feat-item"
                                >
                                  {i === 0 ? (
                                    <div
                                      style={{
                                        background: card?.persuasion_color,
                                      }}
                                      className="featureImgCont"
                                    >
                                      <img
                                        src={GOLD_STAR_URL}
                                        className="golIcImg"
                                      ></img>
                                    </div>
                                  ) : (
                                    <div
                                      className="dotSeperate-feature"
                                      style={{
                                        backgroundColor: card?.persuasion_color,
                                      }}
                                    />
                                  )}
                                  <span
                                    style={{ color: card?.persuasion_color }}
                                    className="brand-feature-text"
                                  >
                                    {feature}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="footer-btn-sec">
          <S.SubText>{data?.payment?.subtext}</S.SubText>
          {holdStatus === API_STATUS.LOADING ||
          checkHobUserStatus === API_STATUS.LOADING ? (
            <S.CabPaymentCont>
              <S.BluePrimaryBtn>
                <S.BtnLoader />
              </S.BluePrimaryBtn>
            </S.CabPaymentCont>
          ) : (
            <S.CabPaymentCont>
              {showSlidingPayment ? (
                <SlideButton
                  mainText={data?.payment?.btn_payment_text}
                  overlayText={sliderSecondaryText}
                  onSlideDone={handleBookClick}
                  reset={reset}
                />
              ) : (
                <S.BluePrimaryBtn onClick={handleBookClick}>
                  {data?.payment?.btn_payment_text}
                </S.BluePrimaryBtn>
              )}
            </S.CabPaymentCont>
          )}
        </div>
        <HobBottomSheet
          isOpen={showWidget}
          onClose={() => onClose(false)}
          welcomeText={welcomeText}
          setInitialText={setWelcomeText}
          fontFamily={"Rubik"}
        >
          <S.BottomSheetTopCont>
            <div className="title">{TRAVELLER_DETAILS}</div>
            <img src={HOB_BOTTOMSHEET_CANCEL} onClick={() => onClose(false)} />
          </S.BottomSheetTopCont>
          <S.BottomSheetSubtitle>
            {PLEASE_CONFIRM_TRAVELLER_DETLS}
          </S.BottomSheetSubtitle>
          <S.BottomSheetCommTxtCont>
            <img src={HOB_BOTTOMSHEET_INFO} />
            <div className="commTitle">{HOB_BOTTOMSHEET_COMM_TXT}</div>
          </S.BottomSheetCommTxtCont>
          <S.GenderContainer>
            {DEFAULT_CONTACT_DETAILS?.map((gender, index) => {
              const isActive = !!(gender?.value === formDetails?.gender);
              return (
                <S.CustomRadioWrap
                  id={gender?.value}
                  onClick={() => onUserDetailsUpdate("gender", gender?.value)}
                  key={`genderAttributes${index}`}
                >
                  <CustomRadioButton
                    isActive={isActive}
                    backgroundColor={"#757575"}
                    borderColor={"#000"}
                  />
                  <S.labelTxt>{gender?.title}</S.labelTxt>
                </S.CustomRadioWrap>
              );
            })}
          </S.GenderContainer>

          <S.InputCont>
            <div className="inoutContVal">
              <div className="title">{HOB_BOTTOMSHEET_FULL_NAME}</div>
              <input
                type="text"
                placeholder="Enter Full Name"
                value={formDetails?.first_name}
                autoFocus={!formDetails?.first_name}
                onChange={(e) =>
                  onUserDetailsUpdate("first_name", e.target.value)
                }
                onBlur={() => {
                  const isNameValid = checkFormError("first_name");
                  setShowInputError({
                    ...showInputError,
                    name: !isNameValid,
                  });
                }}
              />
            </div>
            {showInputError?.name ? (
              <div className="errorText">{PLEASE_ENTER_FULL_NAME}</div>
            ) : null}
          </S.InputCont>
          <S.InputCont width={"calc(100% - 40px)"}>
            <div className="inoutContVal">
              <div className="title">{HOB_BOTTOMSHEET_MOB_NO}</div>
              <div className="prefixInputCont">
                <div className="prefix">+ 91</div>
                <input
                  type="tel"
                  placeholder="Enter Mobile No."
                  value={formDetails?.mobileNumber}
                  autoFocus={
                    !formDetails?.mobileNumber && formDetails?.first_name
                  }
                  onChange={(e) =>
                    onUserDetailsUpdate("mobileNumber", e.target.value)
                  }
                  onBlur={() => {
                    const isMobileValid = checkFormError("mobileNumber");
                    setShowInputError({
                      ...showInputError,
                      mobile: !isMobileValid,
                    });
                  }}
                />
              </div>
            </div>
            {showInputError?.mobile ? (
              <div className="errorText">{PLEASE_ENTER_VALID_MOBILE_NO}</div>
            ) : null}
          </S.InputCont>
          <S.InputCont>
            <div className="inoutContVal">
              <div className="title">{HOB_BOTTOMSHEET_EMAIL}</div>
              <input
                type="email"
                placeholder="Enter Email Id"
                value={formDetails?.email}
                autoFocus={
                  formDetails?.mobileNumber &&
                  formDetails?.first_name &&
                  !formDetails?.email
                }
                onChange={(e) => onUserDetailsUpdate("email", e.target.value)}
                onBlur={() => {
                  const isEmailValid = checkFormError("email");
                  setShowInputError({
                    ...showInputError,
                    email: !isEmailValid,
                  });
                }}
              />
            </div>
            {showInputError?.email ? (
              <div className="errorText">{PLEASE_ENTER_VALID_EMAIL}</div>
            ) : null}
          </S.InputCont>

          <S.BottomSheetBtnCont>
            {holdStatus === API_STATUS.LOADING ? (
              <S.CabPaymentCont>
                <S.BluePrimaryBtn>
                  <S.BtnLoader />
                </S.BluePrimaryBtn>
              </S.CabPaymentCont>
            ) : (
              <S.CabPaymentCont>
                <S.BluePrimaryBtn onClick={handleBookClick}>
                  {HOB_BOTTOMSHEET_CONFIRM_BOOKING}
                </S.BluePrimaryBtn>
              </S.CabPaymentCont>
            )}
          </S.BottomSheetBtnCont>
        </HobBottomSheet>
        <MwebAuth
          lobname="cabs"
          showAuth={showLogin}
          hideLoginViaWhatsApp
          onLoginSuccess={onLoginSuccess}
          enableTruecaller={false}
          onClose={() => onClose(true)}
        />
      </S.BrandListingScreen>
    );
  }
  return null;
};

export default HobListing;
